var initMap = () => {

  const map = new google.maps.Map(document.getElementById("apartments_map_container"), {
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: [
      {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "transit",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      }
    ]
  });
  let bounds = new google.maps.LatLngBounds();

  // Add some markers to the map.
  let gmaps_markers_data = JSON.parse(document.querySelector('#js-gmaps-markers-data').getAttribute('data-content'));
  if (gmaps_markers_data.length > 0) {
    let markers = [];
    for (const marker_data of gmaps_markers_data) {
      const marker = new google.maps.Marker({
        map, title: marker_data.title,
        content: new google.maps.InfoWindow({
          content: marker_data.content,
        }),
        position: marker_data.coordinates,
      });

      bounds.extend(marker_data.coordinates);
      marker.addListener("click", () => {
        marker.content.open(map, marker);
      });
      markers.push(marker);
    }
  } 

  map.fitBounds(bounds);
  map.panToBounds(bounds);
}

const waitUntilGoogleScriptsLoaded = () => {
  if (typeof google === 'undefined') {
    setTimeout(() => {
      waitUntilGoogleScriptsLoaded();
    }, 500);
  } else {
    initMap();
  }
}

window.addEventListener('DOMContentLoaded', () => {
  let map_view_selector = document.querySelector('.js-co-ajax__view-selector[data-selector="map"]');
  if (map_view_selector !== null) {
    map_view_selector.addEventListener('click', function() {
      if (document.getElementById('js-gmaps-script') === null) {
        loadGmapsScripts();
      }
      if (!document.getElementById("apartments_map_container").querySelector('div')) {
        waitUntilGoogleScriptsLoaded();
      }
    });
  }
});

